module.exports = __webpack_public_path__ + "static/media/icon-20-link-2.c0926045.svg";